import { IdeasPlaceI18n } from '../base.message.locales';

export const ideasPlace: IdeasPlaceI18n = {
  button: 'Know more',
  text: `
    <p>
    Ikone addresses challenges of poor and emerging communities by creating and managing a both physical and online multisided platform.
    As matchmakers, we integrate the social league into a real world living lab the of size of 3.000 football fields developed for the last decade. Simultaneously we are running : 
    <ul>
      <li>An industrial and logistics park,</li>
      <li>An innovation and social impact lab</li>
      <li>And a master plan community created from scratch</li>
    </ul></br>
      Soon we will partner with a real fast living lab that companies from all sizes will be able to test, demonstrate and export solutions 10x faster then any other place in the world. Governments will benefit from solutions for urban planning and social innovation improving quality of life of communities.
    </p>`,
  title: 'TEST YOUR \nIDEAS 10X FASTER',
  investment_value: 'We leverage the amount invested by up to 20x',
  cone: {
    title: 'Industrial and logistics park',
    text: `
        It’s one of the vertex of the triangle that holds the city, which is capable of hosting
    every kind of entrepreneur who is socially-oriented. They ae volunteers, scientists,
    inventors, journalists, sociologists , engineers, social activists and any person
    interested in being a parto f the change the world needs. Cone is the industrial vertex
    of the city. There, companies from all over the world have a space and incentive to
    create socially and economically, being a part of the progress the planet needs. Today
    brands such as Unilever, FeEx and over 6 thousand people are already up and running,
    living and working in Convida.`,
  },
  convida: {
    title: 'The solutions capital',
    text: `You came here because you have realized that the cities problems are complete and
    that the indifference does not build anything. The lack of empathy and compassion
    created the problems that we are going to solve with creativity, multiple talent, ideas
    of all shapes and sizes, permanente collaboration and excitment. In Convida, we take
    on the challenges that the UN has listed as the main obstacles for the human
    development. In order to do this, we count on each other ando ne for another
    everything we are capable of. We share responsibilities, experiences, will and skills.
    The sum of all this strength will be the carrier of a better future, more human, happy
    and sustainable of all time.`,
  },
  gzero: {
    title: 'Inovation and social impact lab',
    text: `Is Convida gravity centre. From it, all our ecosystem moves, stimulating and
    challenging people and solutions to solve complex issues. Questioning patterns, status
    quo and everything that can be innovated through social technology, from new
    settings and thoughts and, mainly, through collaborative develpment: this is how we
    optimize, efficiently and applicably every single proposal we make, wherever they may
    improve people’s lives. Gzero is a Living LAb where global names and brands linked to
    the experimental field of trends and well being are already working towards humanity.
    Education takes place in action.`,
  },

  learn_more: {
    title: 'The invincible power of change',
    text: `
        <p>
                                When it’s about accomplishing local or multinational actions, ideas
                                do not fall short, ideas that any venture demands a lot of work and
                                generates poor numbers in results. An explanation for this way of
                                thinking is the effective existence of various kinds of obstacles.
                                These are legal issues, tax, border or normative customs that involve
                                countless authorities and institutions. The good news is that every
                                effort is a result multiplied by 20. Yes, that’s exactly what you’ve
                                read: it’s hard work, but the analysis made by Ikone – Social League
                                – show a pattern: It is really Worth calling, asking, advising, giving,
                                applying oneself to it, talking, unlocking bureaucracies, helping with
                                personal or team effort, getting involved in the implementation of an
                                idea. And why? Because if the might put in bringing to Brazil, for
                                instance, a humanitarian action with global reach demands hard work,
                                it’s equivalent to 5% of the figure involved to get the initiative going.
                                Striking. Isn’t it? Which means: a participation with R$ 500 thousand
                                reais (expertise, networking, donations, time, meetings, phone calls,
                                documents preparation, personal support) will have as a result an impact
                                of 10 million invested socially.
                            </p>

                            <p>
                                Own the power you have. Be the change that you want to see in the world.
                            </p>`,
  },
};
